import { CategoryPage } from '../pages/CategoryPage';

export function ResponsiveCategoryPage() {
  return <CategoryPage />;
}
